import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Excel from '@grapecity/spread-excelio';
import * as GC from '@grapecity/spread-sheets';
import { InterceptorSkipHeader } from '@models/headers/interceptor-skip-header';
import { AppConfig } from '@models/types/appconfig';
import { ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AppConfigProvider {
  public environment: ReplaySubject<AppConfig> = new ReplaySubject(1);

  constructor(private http: HttpBackend) {}

  load() {
    const headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    const httpClient = new HttpClient(this.http);

    return httpClient
      .get('../config.json', { headers })
      .pipe(
        tap((configFile: AppConfig) => {
          this.environment.next(configFile);
          GC.Spread.Sheets.LicenseKey = configFile.SPREAD.LICENSE;
          (Excel as any).LicenseKey = configFile.SPREAD.LICENSE;
        })
      )
      .toPromise();
  }
}
